import { Instance, types } from 'mobx-state-tree'
import { capitalize } from '@mui/material'

export const PurchaseAttempt = types
  .model('PurchaseAttempt')
  .props({
    id: types.identifierNumber,
    attempt_timestamp: types.string,
    details: types.maybeNull(types.string),
    status: types.string,
  })
  .views((self) => ({
    get isFailed() {
      return self.status === 'failed'
    },
    get isPending() {
      return self.status === 'pending'
    },
    get isCompleted() {
      return self.status === 'completed'
    },
  }))

export type PurchaseAttemptType = Instance<typeof PurchaseAttempt>
